// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as ApolloConfig from "../../core/ApolloConfig.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as InputTextAreaField from "../../resources/selection-and-input/InputTextAreaField.res.js";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation updateProduct_internalNote($id: ID!, $input: InputUpdateProduct!)  {\nupdateProduct(id: $id, input: $input)  {\n__typename  \nid  \ninternalNote  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.updateProduct;
  let value$2 = value$1.internalNote;
  return {
    updateProduct: {
      __typename: value$1.__typename,
      id: value$1.id,
      internalNote: !(value$2 == null) ? Scalar.Text.parse(value$2) : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.updateProduct;
  let value$2 = value$1.internalNote;
  let internalNote = value$2 !== undefined ? Scalar.Text.serialize(value$2) : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let updateProduct = {
    __typename: value$4,
    id: value$3,
    internalNote: internalNote
  };
  return {
    updateProduct: updateProduct
  };
}

function serializeInputObjectInputUpdateProductMetaData(inp) {
  let a = inp.shopifyProductId;
  return {
    shopifyProductId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputUpdateProduct(inp) {
  let a = inp.name;
  let a$1 = inp.designation;
  let a$2 = inp.color;
  let a$3 = inp.kind;
  let a$4 = inp.family;
  let a$5 = inp.producer;
  let a$6 = inp.country;
  let a$7 = inp.region;
  let a$8 = inp.beerType;
  let a$9 = inp.wineType;
  let a$10 = inp.whiteWineType;
  let a$11 = inp.internalNote;
  let a$12 = inp.taxId;
  let a$13 = inp.categoryId;
  let a$14 = inp.metadata;
  return {
    name: a !== undefined ? a : undefined,
    designation: a$1 !== undefined ? a$1 : undefined,
    color: a$2 !== undefined ? (
        a$2 === "ORANGE" ? "ORANGE" : (
            a$2 === "RED" ? "RED" : (
                a$2 === "AMBER" ? "AMBER" : (
                    a$2 === "DARK" ? "DARK" : (
                        a$2 === "BLACK" ? "BLACK" : (
                            a$2 === "BLOND" ? "BLOND" : (
                                a$2 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : undefined,
    kind: a$3 !== undefined ? (
        a$3 === "SPIRITUOUS" ? "SPIRITUOUS" : (
            a$3 === "BEER" ? "BEER" : (
                a$3 === "WINE" ? "WINE" : "SIMPLE"
              )
          )
      ) : undefined,
    family: a$4 !== undefined ? a$4 : undefined,
    producer: a$5 !== undefined ? a$5 : undefined,
    country: a$6 !== undefined ? a$6 : undefined,
    region: a$7 !== undefined ? a$7 : undefined,
    beerType: a$8 !== undefined ? a$8 : undefined,
    wineType: a$9 !== undefined ? (
        a$9 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL"
      ) : undefined,
    whiteWineType: a$10 !== undefined ? (
        a$10 === "SWEET" ? "SWEET" : (
            a$10 === "SEMIDRY" ? "SEMIDRY" : (
                a$10 === "SOFT" ? "SOFT" : "DRY"
              )
          )
      ) : undefined,
    internalNote: a$11 !== undefined ? a$11 : undefined,
    taxId: a$12 !== undefined ? a$12 : undefined,
    categoryId: a$13 !== undefined ? a$13 : undefined,
    metadata: a$14 !== undefined ? serializeInputObjectInputUpdateProductMetaData(a$14) : undefined
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateProduct(inp.input)
  };
}

function makeVariables(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateProduct(name, designation, color, kind, family, producer, country, region, beerType, wineType, whiteWineType, internalNote, taxId, categoryId, metadata, param) {
  return {
    name: name,
    designation: designation,
    color: color,
    kind: kind,
    family: family,
    producer: producer,
    country: country,
    region: region,
    beerType: beerType,
    wineType: wineType,
    whiteWineType: whiteWineType,
    internalNote: internalNote,
    taxId: taxId,
    categoryId: categoryId,
    metadata: metadata
  };
}

function makeInputObjectInputUpdateProductMetaData(shopifyProductId, param) {
  return {
    shopifyProductId: shopifyProductId
  };
}

let UpdateProductInternalNoteMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateProduct: serializeInputObjectInputUpdateProduct,
  serializeInputObjectInputUpdateProductMetaData: serializeInputObjectInputUpdateProductMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateProduct: makeInputObjectInputUpdateProduct,
  makeInputObjectInputUpdateProductMetaData: makeInputObjectInputUpdateProductMetaData
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let UpdateProductInternalNoteMutation_useWithVariables = include.useWithVariables;

let UpdateProductInternalNoteMutation = {
  UpdateProductInternalNoteMutation_inner: UpdateProductInternalNoteMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateProduct: serializeInputObjectInputUpdateProduct,
  serializeInputObjectInputUpdateProductMetaData: serializeInputObjectInputUpdateProductMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateProduct: makeInputObjectInputUpdateProduct,
  makeInputObjectInputUpdateProductMetaData: makeInputObjectInputUpdateProductMetaData,
  use: use,
  useWithVariables: UpdateProductInternalNoteMutation_useWithVariables
};

function CatalogProductNoteCard(props) {
  let initialInternalNote = props.internalNote;
  let productId = props.productId;
  let match = React.useState(() => initialInternalNote);
  let setInternalNote = match[1];
  let internalNote = match[0];
  let debouncedInternalNote = ReactUpdateDebounced.use(internalNote, ApolloConfig.mutationDebounceInterval);
  let match$1 = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutateInternalNote = match$1[0];
  let match$2 = React.useState(() => "None");
  let setError = match$2[1];
  let error = match$2[0];
  let onMutateInternalNoteRequested = React.useCallback(internalNote => {
    let input = makeInputObjectInputUpdateProduct(undefined, undefined, undefined, undefined, undefined, undefined, I18n.t("France"), undefined, undefined, undefined, undefined, Scalar.Text.serialize(internalNote), undefined, undefined, undefined, undefined);
    Future.get(FuturePromise.fromPromise(mutateInternalNote(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: Stdlib_Option.getOr(productId, ""),
      input: input
    })), result => {
      if (result.TAG === "Ok") {
        let match = result._0;
        if (match.TAG === "Ok" && match._0.error === undefined) {
          return setError(param => "None");
        }
      }
      setInternalNote(param => initialInternalNote);
      setError(param => ({
        TAG: "InternalNoteUpdatingError",
        _0: I18n.t("Couldn't update the internal note.")
      }));
    });
  }, [productId]);
  ReactUpdateEffect.use1(() => {
    onMutateInternalNoteRequested(debouncedInternalNote);
  }, [debouncedInternalNote]);
  let match$3 = Auth.useScope();
  let tmp;
  let exit = 0;
  if (match$3.TAG === "Organisation" && match$3.activeShop === undefined) {
    tmp = JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Banner.make, {
        textStatus: {
          TAG: "Info",
          _0: I18n.t("Please filter the product page on a single shop to edit its internal memo.")
        },
        compact: false
      }),
      spaceTop: "medium"
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let tmp$1;
    tmp$1 = typeof error !== "object" ? undefined : error._0;
    tmp = JsxRuntime.jsx(Stack.make, {
      children: JsxRuntime.jsx(InputTextAreaField.make, {
        label: I18n.t("Internal memo"),
        errorMessage: tmp$1,
        value: internalNote,
        onChange: value => setInternalNote(param => value)
      }),
      space: "xlarge"
    });
  }
  return JsxRuntime.jsx(Card.make, {
    children: tmp,
    title: "Note"
  });
}

let make = React.memo(CatalogProductNoteCard);

export {
  UpdateProductInternalNoteMutation,
  make,
}
/* query Not a pure module */
